export const REQUEST_AUTH_START = 'REQUEST_AUTH_START';
export const AUTH_GET_USER_TOKEN_SUCCESS = 'AUTH_GET_USER_TOKEN_SUCCESS';
export const REQUEST_API_ERROR = "REQUEST_API_ERROR";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const REQUEST_START = "REQUEST_START";
export const REQ_ALERT = "REQ_ALERT";
export const REQUEST_ERROR = "REQUEST_ERROR";
export const REQUEST_VERIFY_EMAIL_SUCCESS = "REQUEST_VERIFY_EMAIL_SUCCESS";
export const REQUEST_VERIFY_EMAIL_ERROR = "REQUEST_VERIFY_EMAIL_ERROR";

export const REQUEST_VERIFY_CORPORATE_EMAIL_SUCCESS = "REQUEST_VERIFY_CORPORATE_EMAIL_SUCCESS";
export const REQUEST_VERIFY_CORPORATE_EMAIL_START = "REQUEST_VERIFY_CORPORATE_EMAIL_START";
export const REQUEST_VERIFY_CORPORATE_EMAIL_ERROR = "REQUEST_VERIFY_CORPORATE_EMAIL_ERROR";

export const AUTH_GET_CURRENT_USER_REQUEST = 'AUTH_GET_CURRENT_USER_REQUEST';
export const AUTH_GET_CURRENT_USER_ERROR = 'AUTH_GET_CURRENT_USER_ERROR';
export const AUTH_REGISTER_USER_SUCCESS = 'AUTH_REGISTER_USER_SUCCESS';
export const AUTH_LOGIN_USER_SUCCESS = 'AUTH_LOGIN_USER_SUCCESS';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const CHANGE_SIGN_UP = 'CHANGE_SIGN_UP';
export const CHANGE_LOGIN = 'CHANGE_LOGIN';
export const REQUEST_GET_USER_SHARING_DISCOUNT_START = 'REQUEST_GET_USER_SHARING_DISCOUNT_START';
export const REQUEST_GET_USER_SHARING_DISCOUNT_ERROR = 'REQUEST_GET_USER_SHARING_DISCOUNT_ERROR';
export const REQUEST_GET_USER_SHARING_DISCOUNT_SUCCESS = 'REQUEST_GET_USER_SHARING_DISCOUNT_SUCCESS';
export const USER_LOGGED = 'USER_LOGGED';

